import { render, staticRenderFns } from "./FashionServices.vue?vue&type=template&id=77aa3d0a&scoped=true&"
import script from "./FashionServices.vue?vue&type=script&lang=js&"
export * from "./FashionServices.vue?vue&type=script&lang=js&"
import style0 from "./FashionServices.vue?vue&type=style&index=0&id=77aa3d0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aa3d0a",
  null
  
)

export default component.exports